module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create category","eventsCategoriesActionsCreateSuccess":"%{eventsCategoryName} was successfully added to the database"},"no":{"dialogTitle":"Opprett kategori","eventsCategoriesActionsCreateSuccess":"%{eventsCategoryName} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
